import { useEffect } from 'react'
import { useToast } from '../store/toast.ts'

/**
 * Полоска внизу экрана: живёт две секунды и уходит сама.
 *
 * Висит в обёртке приложения одна на всё — так она не мешает
 * разделам знать друг о друге и не всплывает дважды.
 */
export function Toast() {
  const toast = useToast((s) => s.toast)
  const hide = useToast((s) => s.hide)

  useEffect(() => {
    if (!toast) return
    const timer = window.setTimeout(hide, 2200)
    return () => window.clearTimeout(timer)
    // Время отсчитывается заново на каждое новое сообщение —
    // иначе второе исчезнет по таймеру первого
  }, [toast, hide])

  if (!toast) return null

  return (
    <div className={'toast toast-' + toast.kind} role="status" aria-live="polite">
      {toast.text}
    </div>
  )
}
